import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import { Autocomplete as MuiAutoComplete } from '@mui/material';
import React from 'react';
import Styles from './DomElements.scss';
import Label from './Label';

export const Autocomplete = React.forwardRef(function Autocomplete(
    props: any,
    ref
) {
    const selectIcon = props.isOpen ? (
        <KeyboardArrowUp />
    ) : (
        <KeyboardArrowDown />
    );

    return (
        <MuiAutoComplete
            ref={ref}
            {...props}
            renderInput={(params) => (
                <div
                    ref={params.InputProps.ref}
                    className={Styles.domElContainer}
                >
                    {props.label && <Label text={props.label} />}
                    <input
                        type="text"
                        {...params.inputProps}
                        className={Styles.textbox}
                        placeholder={props.placeholder}
                    />
                </div>
            )}
            classes={{ option: Styles.autocompleteOption }}
        />
    );
});
